import { useState, useEffect } from 'react'
import { Navbar } from '@/components/Navbar'
import { FunctionBar } from './sections/FunctionBar'
import { DashboardContent } from './sections/DashboardContent'
import { AnalyzeContent } from './sections/AnalyzeContent'
import apiService from '@/api/service'

export const Dashboard = (): JSX.Element => {
    const [activeTab, setActiveTab] = useState<'overview' | 'analyze'>('overview')
    const [storeName, setStoreName] = useState<string>('美味餐廳')

    // 從 localStorage 讀取店家名稱
    useEffect(() => {
        const storeInfo = apiService.getStoreInfo()
        if (storeInfo && storeInfo.name) {
            console.log('讀取店家名稱:', storeInfo.name)
            setStoreName(storeInfo.name)
        }

        // 監聽店家資訊更新事件
        const handleStoreInfoUpdate = (event: Event) => {
            const customEvent = event as CustomEvent
            if (customEvent.detail && customEvent.detail.name) {
                console.log('店家資訊已更新，更新店家名稱:', customEvent.detail.name)
                setStoreName(customEvent.detail.name)
            }
        }

        window.addEventListener('storeInfoUpdated', handleStoreInfoUpdate)

        // 清理函數
        return () => {
            window.removeEventListener('storeInfoUpdated', handleStoreInfoUpdate)
        }
    }, [])

    return (
        <div
            className="flex flex-col min-h-screen w-full items-start relative bg-white"
            data-model-id="1:3140"
        >
            <Navbar />
            <div className="flex flex-col w-full flex-1 items-start relative bg-[#e8d080] overflow-y-auto">
                {/* 頂部封面區域 - 响应式 */}
                <div className="relative w-full min-h-[350px] md:min-h-[450px] lg:min-h-[520px] bg-white border-b-2 md:border-b-[3px] [border-bottom-style:solid]">
                    {/* 封面圖片容器 - 响应式 */}
                    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full max-w-[1200px] h-[280px] md:h-[340px] lg:h-[400px] flex bg-[#cbcbcb] rounded-[0px_0px_35px_35px] md:rounded-[0px_0px_50px_50px] overflow-hidden">
                        <img
                            className="w-full h-full object-cover"
                            alt="Image"
                            src="/img/image-7.png"
                        />
                    </div>

                    {/* Logo 和餐廳名稱容器 - 响应式 */}
                    <div className="absolute top-[250px] md:top-[300px] lg:top-[370px] left-1/2 transform -translate-x-1/2 w-full max-w-[1200px] h-[120px] md:h-[150px] lg:h-[180px] px-4">
                        {/* Logo 和餐廳名稱 - 响应式 */}
                        <div className="absolute left-4 md:left-0 flex items-center gap-3 md:gap-4">
                            <div className="w-[100px] h-[100px] md:w-[140px] md:h-[140px] lg:w-[180px] lg:h-[180px] bg-[url(/img/ellipse-91.png)] bg-cover bg-[50%_50%] flex-shrink-0" />

                            <div className="flex items-center justify-start [font-family:'Noto_Sans_TC',Helvetica] font-medium text-[#373737] text-xl md:text-3xl lg:text-4xl tracking-[4.00px] md:tracking-[6.00px] lg:tracking-[7.20px] leading-tight md:leading-9 whitespace-nowrap">
                                {storeName}
                            </div>
                        </div>
                    </div>
                </div>

                {/* 主要內容區域 - 响应式 */}
                <div className="flex flex-col items-center w-full pt-8 md:pt-[50px] pb-12 md:pb-20 px-4 md:px-8 lg:px-[120px] relative">
                    <div className="w-full max-w-[1200px]">
                        <FunctionBar activeTab={activeTab} onTabChange={setActiveTab} />
                        {activeTab === 'overview' ? <DashboardContent /> : <AnalyzeContent />}
                    </div>
                </div>
            </div>
        </div>
    )
}
